import React from "react";
import { Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { IoClose } from "react-icons/io5";

export default function ThreeDLiveModal({ show, onHide }) {
    return (
        <Modal size="xl" className="video-modal modal-overlay" aria-labelledby="contained-modal-title-vcenter " show={show} centered>
            <button className="close-btn" onClick={onHide}>
                <IoClose />
            </button>
            <Modal.Body>
                <div className="modal-slider-container video-slide accordion-swiper-modal">
                    <Swiper modules={[Navigation]} spaceBetween={20} slidesPerView={1} navigation loop={false} className="swiper-container">
                        <SwiperSlide>
                            <iframe
                                src="https://sketchfab.com/models/defa045de27b418e82377c496bbb965d/embed?autostart=true&autospin=0&transparent=false&ui_infos=false&ui_inspector=false&ui_settings=false&ui_controls=true&ui_general_controls=false&ui_annotations=true&ui_color=28b16d&preload=false&ui_watermark_link=false&ui_watermark=false&ui_stop=false"
                                title="Example Website"
                                width="100%"
                                height="500px"
                                frameBorder="0"
                            ></iframe>
                        </SwiperSlide>
                    </Swiper>
                    {/* <Swiper modules={[Navigation]} spaceBetween={20} slidesPerView={1} initialSlide={id} navigation loop={false} className="swiper-container">
                        {propertyVdosmdl.length > 0 &&
                            propertyVdosmdl
                                .filter((img) => !img.needHide)
                                .sort((a, b) => {
                                    if (a.isCover) return -1;
                                    if (b.isCover) return 1;
                                    return a.orderRank - b.orderRank;
                                })
                                .map((slide, index) => (
                                    <SwiperSlide key={index}>
                                        <video 
                                        // autoPlay loop 
                                        controls className="" >
                                            <source src={imgBaseUrl + slide?.path} type="video/mp4" />
                                        </video>
                                    </SwiperSlide>
                                ))}
                    </Swiper> */}
                </div>
            </Modal.Body>
        </Modal>
    );
}
